<p>app-add-ons-side-bar works!</p>
<button>Complete The Tansaction</button>